import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import CookieConsent from './CookieConsent';
import WelcomeModal from './WelcomeModal';

const COOKIE_CONSENT_KEY = 'jobasti_cookie_consent';
const WELCOME_SHOWN_KEY = 'jobasti_welcome_shown';

const PublicLayout = ({ children }) => {
  const { slug } = useParams();
  const [cookieDone, setCookieDone] = useState(() => !!localStorage.getItem(COOKIE_CONSENT_KEY));
  const [welcomeDone, setWelcomeDone] = useState(() => !!localStorage.getItem(WELCOME_SHOWN_KEY));
  const [orgName, setOrgName] = useState('');

  useEffect(() => {
    if (slug && !welcomeDone) {
      axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/public/orgs/${slug}/positions`)
        .then(res => {
          if (res.data?.data?.organization?.name) {
            setOrgName(res.data.data.organization.name);
          }
        })
        .catch(() => {});
    }
  }, [slug, welcomeDone]);

  return (
    <>
      {!cookieDone && (
        <CookieConsent onConsented={() => setCookieDone(true)} />
      )}
      {cookieDone && !welcomeDone && (
        <WelcomeModal orgName={orgName} onDismiss={() => setWelcomeDone(true)} />
      )}
      {children}
    </>
  );
};

export default PublicLayout;
